"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Select = void 0;

var React = _interopRequireWildcard(require("react"));

var _FormFieldWrapper = _interopRequireDefault(require("../FormFieldWrapper/FormFieldWrapper"));

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _useActiveClassName2 = require("../../customHooks/useActiveClassName");

var _selectConfig = require("./selectConfig");

var _types = require("../../types");

var _validation = require("../../types/validation");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _selectConfig.SelectDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true), _flowRuntime["default"].property("select", _flowRuntime["default"].ref(SelectDefinition)), _flowRuntime["default"].property("onChange", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())), true), _flowRuntime["default"].property("noOptionalLabel", _flowRuntime["default"]["boolean"](), true)));

var SelectProps = _flowRuntime["default"].type("SelectProps", _flowRuntime["default"].object(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("input", _flowRuntime["default"].object()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("select", _flowRuntime["default"].ref(SelectDefinition))));

var Select = function Select(_arg) {
  var disabled = _arg.disabled,
      input = _arg.input,
      inputStyle = _arg.inputStyle,
      isRequired = _arg.isRequired,
      select = _arg.select;

  var _useActiveClassName = (0, _useActiveClassName2.useActiveClassName)(input),
      activeClassName = _useActiveClassName.activeClassName;

  var getValidationClass = function getValidationClass() {
    if (inputStyle && inputStyle.inputClass && inputStyle.inputClass.includes('error')) {
      return 'error';
    }

    if (inputStyle && inputStyle.inputClass && inputStyle.inputClass.includes('success')) {
      return 'success';
    }

    return '';
  };

  var className = "".concat(inputStyle.inputClass, " ").concat(activeClassName('input'));
  var labelClassName = "".concat(activeClassName('label'), " ").concat(getValidationClass());
  return /*#__PURE__*/React.createElement("div", {
    className: "float-label"
  }, /*#__PURE__*/React.createElement("select", Object.assign({
    className: className,
    disabled: disabled,
    id: input.name
  }, input), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, !select.label && !isRequired ? ' (optional)' : ''), select.items && select.items.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.value || item.key,
      value: item.value || item.key
    }, item.label || item.value || item.key);
  })), /*#__PURE__*/React.createElement("label", {
    className: labelClassName,
    htmlFor: input.name
  }, /*#__PURE__*/React.createElement(_FieldLabel["default"], {
    field: select,
    isRequired: isRequired
  })));
};

exports.Select = Select;
Select.defaultProps = {
  disabled: false
};

var RFSelect = function RFSelect(_arg2) {
  var disabled = _arg2.disabled,
      select = _arg2.select,
      inheritedFieldValidation = _arg2.inheritedFieldValidation,
      onChange = _arg2.onChange,
      noOptionalLabel = _arg2.noOptionalLabel;
  return /*#__PURE__*/React.createElement(_FormFieldWrapper["default"], {
    field: select,
    renderField: function renderField(_ref) {
      var input = _ref.input,
          inputStyle = _ref.inputStyle,
          isRequired = _ref.isRequired;
      return /*#__PURE__*/React.createElement(Select, {
        disabled: disabled,
        input: input,
        inputStyle: inputStyle,
        isRequired: noOptionalLabel ? true : isRequired,
        select: select,
        noOptionalLabel: noOptionalLabel
      });
    },
    inheritedFieldValidation: inheritedFieldValidation,
    onChange: onChange
  });
};

RFSelect.defaultProps = {
  disabled: false,
  inheritedFieldValidation: [],
  onChange: undefined,
  noOptionalLabel: false
};
var _default = RFSelect;
exports["default"] = _default;